import {
  afterNextRender,
  Directive,
  effect,
  ElementRef,
  inject,
  input,
  OnDestroy,
  output,
} from '@angular/core';

@Directive({
  selector: '[hypenationInfiniteScroll]',
  standalone: true,
})
export class InfiniteScrollDirective implements OnDestroy {
  public readonly hasMore = input.required<boolean>();
  public readonly loadingMore = input.required<boolean>();
  public readonly rootMargin = input<string>('200px');
  public readonly scrollEnd = output<void>();

  private readonly host = inject(ElementRef<HTMLElement>);
  private observer: IntersectionObserver | null = null;

  constructor() {
    afterNextRender(() => this.connect());

    effect(() => {
      const more = this.hasMore();
      if (!more) {
        this.disconnect();
      } else if (!this.observer) {
        this.connect();
      }
    });
  }

  ngOnDestroy(): void {
    this.disconnect();
  }

  private connect(): void {
    if (typeof IntersectionObserver === 'undefined') {
      return;
    }
    if (!this.hasMore()) {
      return;
    }
    this.observer?.disconnect();
    this.observer = new IntersectionObserver(
      (entries) => {
        for (const entry of entries) {
          if (
            entry.isIntersecting &&
            this.hasMore() &&
            !this.loadingMore()
          ) {
            this.scrollEnd.emit();
          }
        }
      },
      { rootMargin: this.rootMargin() }
    );
    this.observer.observe(this.host.nativeElement);
  }

  private disconnect(): void {
    this.observer?.disconnect();
    this.observer = null;
  }
}
